document.addEventListener("DOMContentLoaded", () => {

  // IMAGE RESIZE
  let resizing = false;
  let activeImageLayer = null;
  let startWidth = 0;
  let startX = 0;

  // TEXT RESIZE
  let resizingText = null;
  let startTextX = 0;
  let startFontSize = 0;

  document.addEventListener("mousedown",(e)=>{

  // IMAGE HANDLE
  if(
    e.target.classList.contains("resize-handle")
  ){

    activeImageLayer =
      e.target.closest(".embroidery-image-layer");

    if(!activeImageLayer) return;

    resizing = true;

    startWidth =
      activeImageLayer.offsetWidth;

    startX =
      e.clientX;

    e.preventDefault();
    return;
  }

  // TEXT HANDLE
  if(
    e.target.classList.contains("text-resize-handle")
  ){

    resizingText =
      e.target.closest(".embroidery-text-layer");

    if(!resizingText) return;

    startTextX =
      e.clientX;

    startFontSize =
      parseInt(
        window.getComputedStyle(
          resizingText
        ).fontSize
      );

    e.preventDefault();
  }

});

  document.addEventListener("mousemove",(e)=>{

  // IMAGE RESIZE
  if(resizing && activeImageLayer){

    let width =
      startWidth +
      (e.clientX - startX);

    if(width < 40)
      width = 40;

    if(width > 600)
      width = 600;

    activeImageLayer.style.width =
      width + "px";
  }

  // TEXT RESIZE
  if(resizingText){

    let newSize =
      startFontSize +
      ((e.clientX - startTextX) / 2);

    if(newSize < 12)
      newSize = 12;

    if(newSize > 150)
      newSize = 150;

    resizingText.querySelectorAll(".curve-letter")
.forEach(letter => {
  letter.style.fontSize =
    newSize + "px";
});
      resizingText.dataset.fontSize =
Math.round(newSize);
  }

});

  document.addEventListener("mouseup",()=>{

  if(resizing || resizingText){

document.dispatchEvent(
new Event("embroideryUpdated")
);

window.EMBStorage?.save();

}

resizing = false;
activeImageLayer = null;

resizingText = null;

});

});